import React from "react";
import {
  error_check_fn,
  ORGANIZATION_ID,
  SERVER_BASE_URL,
  steps_array,
} from "../utils";
import axios from "axios";
import _ from "lodash";
import { LoadingOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const Buttons = ({
  page,
  setPage,
  data,
  setData,
  error,
  setError,
  redbox,
  setRedbox,
  btnLoading,
  setBtnLoading,
  offlineDisabled,
  progress,
  setProgress,
  disabled,
  config,
  setConfig,
  setMessage
}) => {
  const back = () => {
    if (page === 1) return;
    setBtnLoading(false);

    setRedbox(false);

    setPage((prev) => prev - 1);
  };

  const next = async () => {
    console.log("page",page)
    if (disabled?.stage) {
      if (page === 7) return;

      setPage((prev) => prev + 1);
      return;
    }

    let stop_navigation = false;

    setRedbox(false);
    setBtnLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 0));

    let application_id = window.sessionStorage.getItem("application_id");

    if (page === 1 && data?.register_as === "Download Registration Form") {
      let is_valid = error_check_fn({
        // required_fields: ["download_op_name", "download_legal_broker_name"],
        // required_email: ["download_gen_email"],
        // required_phone: ["download_ho_phone"],
        required_fields: ["download_op_name", "download_legal_broker_name",'a_name'],
        required_email: ["download_gen_email",'a_email'],
        required_phone: ["download_ho_phone",'a_phoneNumber'],
        data,
        error,
        setError,
      });

      if (!is_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      await axios
        .post(`${SERVER_BASE_URL}/application/create_application`, {
          organization_id: ORGANIZATION_ID,
          registration: data?.register_as,
          legal_name_of_brokerage: data?.download_legal_broker_name,
          operating_name: data?.download_op_name,
          general_email: data?.download_gen_email,
          head_office_phone: data?.download_ho_phone,
          applicant_name : data?.a_name,
          applicant_email : data?.a_email,
          applicant_phoneNumber: data?.a_phoneNumber
        })
        .then((response) => {
          console.log(response);

          if (response.data.success) {
            application_id = response.data?.data?.server_id;
            window.sessionStorage.setItem("application_id", application_id);
            window.sessionStorage.setItem(
              "application_number",
              response.data?.data?.application_number
            );
          } else if(response.data?.message === "Application already created") {
             
              stop_navigation = true;
              // notification.error({
              //   message: `Application already created with this email`,
              //   duration: 5,
              // });

              setConfig({
                ...config,
                existing_application: true,
                ea_modal_open: true,
              });
           setMessage(response.data.message)
            return;
          }
          else {
             stop_navigation = true;
              // notification.error({
              //   message: `Application already created with this email`,
              //   duration: 5,
              // });

              setConfig({
                ...config,
                existing_application: true,
                ea_modal_open: true,
              });
              setMessage(response.data.message)


            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      page === 2 &&
      data?.register_as === "Download Registration Form"
    ) {
    } else if (
      page === 1 &&
      data?.register_as === "Complete Registration Online"
    ) {
      let is_valid = error_check_fn({
        required_fields: [
          "operating_name",
          "legal_name_of_brokage",
          "ho_street",
          "ho_city",
          "ho_province",
          "ho_country",
            "a_name"
        ],
        required_email: ["general_email","a_email"],
        required_pc: ["ho_pc"],
        required_phone: ["ho_phone_number","a_phoneNumber"],
        data,
        error,
        setError,
      });

      if (!is_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      if (application_id) {
        await axios
          .post(`${SERVER_BASE_URL}/application/update_application`, {
            server_id: application_id,
            updates: {
              organization_id: ORGANIZATION_ID,
              registration: data?.register_as,
              general_email: data?.general_email,
              legal_name_of_brokerage: data?.legal_name_of_brokage,
              operating_name: data?.operating_name,
              head_office_phone: data?.ho_phone_number,
              head_office_street: data?.ho_street,
              head_office_line2: data?.ho_line2,
              head_office_country: data?.ho_country,
              head_office_province: data?.ho_province,
              head_office_city: data?.ho_city,
              head_office_pc: data?.ho_pc,
              applicant_email : data?.a_email,
              applicant_name : data?.a_name,
              applicant_phoneNumber : data?.a_phoneNumber,
              progress:
                progress > Number(steps_array[page].percent)
                  ? progress
                  : Number(steps_array[page].percent),
            },
          })
          .then((response) => {
            console.log(response);
            setProgress(
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent)
            );

            if (response.data.success) {
              application_id = response.data?.data?.server_id;
              window.sessionStorage.setItem("application_id", application_id);
              window.sessionStorage.setItem(
                "application_number",
                response.data?.data?.application_number
              );
            }
           else {
                stop_navigation = true;
                // return notification.error({
                //   message: `Application already created with this email`,
                //   duration: 5,
                // });

                setConfig({
                  ...config,
                  existing_application: true,
                  ea_modal_open: true,
                });
                setMessage(response.data.message)
              }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await axios
          .post(`${SERVER_BASE_URL}/application/create_application`, {
            organization_id: ORGANIZATION_ID,
            registration: data?.register_as,
            general_email: data?.general_email,
            legal_name_of_brokerage: data?.legal_name_of_brokage,
            operating_name: data?.operating_name,
            head_office_phone: data?.ho_phone_number,
            head_office_street: data?.ho_street,
            head_office_line2: data?.ho_line2,
            head_office_country: data?.ho_country,
            head_office_province: data?.ho_province,
            head_office_city: data?.ho_city,
            head_office_pc: data?.ho_pc,
            applicant_email : data?.a_email,
            applicant_name : data?.a_name,
            applicant_phoneNumber : data?.a_phoneNumber,
            progress: Number(steps_array[page].percent),
          })
          .then((response) => {
            console.log(response);

            setProgress(
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent)
            );

            if (response.data.success) {
              application_id = response.data?.data?.server_id;
              window.sessionStorage.setItem("application_id", application_id);
              window.sessionStorage.setItem(
                "application_number",
                response.data?.data?.application_number
              );
            } else if (response.data?.message === "Application already created") {
                stop_navigation = true;
                // return notification.error({
                //   message: `Application already created with this email`,
                //   duration: 5,
                // });

                setConfig({
                  ...config,
                  existing_application: true,
                  ea_modal_open: true,
                });
                setMessage(response.data.message)
              }
              else {
                  stop_navigation = true;
                // return notification.error({
                //   message: `Application already created with this email`,
                //   duration: 5,
                // });

                setConfig({
                  ...config,
                  existing_application: true,
                  ea_modal_open: true,
                });
                setMessage(response?.data?.message)
              }
            
          })
          .catch((err) => {
            console.log(err);
          });
      }

      console.log("two");
    } else if (
      page === 2 &&
      data?.register_as === "Complete Registration Online"
    ) {
      let required_subform = [];

      if (data?.is_ho_the_branch === false) {
        required_subform.push("list_of_branches");
      }

      let is_subform_valid = error_check_fn({
        required_subform: required_subform,
        data,
        error,
        setError,
      });

      if (!is_subform_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      let branch_details = [];

      // Filter out empty branches - only include branches with actual data
      if (data?.list_of_branches && data?.list_of_branches.length > 0) {
        branch_details = data?.list_of_branches.filter(branch => {
          // Keep head office branch
          if (branch.key === "head-office") return true;
          // Keep branches that have at least a name, address, phone, or city
          return branch.branch_name || branch.address || branch.phone || branch.city;
        });
      }

      // If head office is a branch but not in the list, add it
      if (data?.is_ho_the_branch && !branch_details.some(b => b.key === "head-office")) {
        const headOfficeBranch = {
          key: "head-office",
          branch_name: data?.operating_name || data?.legal_name_of_brokage || "Head Office",
          address: data?.ho_street || "",
          line2: data?.ho_line2 || "",
          country: data?.ho_country || "Canada",
          city: data?.ho_city || "",
          province: data?.ho_province || "",
          postal_code: data?.ho_pc || "",
          phone: data?.ho_phone_number || "",
        };
        branch_details = [headOfficeBranch, ...branch_details];
      }

      console.log(branch_details);

      if (application_id) {
        await axios
          .post(`${SERVER_BASE_URL}/application/update_application`, {
            server_id: application_id,
            updates: {
              branch_details: branch_details,
              progress:
                progress > Number(steps_array[page].percent)
                  ? progress
                  : Number(steps_array[page].percent),
              is_head_office_the_branch: data?.is_ho_the_branch,
            },
          })
          .then((response) => {
            console.log(response);
            setProgress(
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent)
            );
            let branches = _.merge(
              [],
              data?.list_of_branches,
              response.data?.data?.branch_details
            );

            setData({ ...data, list_of_branches: branches });

            console.log(branches);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else if (page === 3) {
      let required_subform = ["contracts"];

      if (data?.no_mga === false) {
        required_subform.push("mga");
      }

      let is_subform_valid = error_check_fn({
        required_subform: required_subform,
        data,
        error,
        setError,
      });

      if (!is_subform_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      let atleast_one_mga = data?.mga.some((item) => item?.mga_name);

      let mga = [];

      if (atleast_one_mga) {
        mga = data?.mga;
      }

      let contracts = data?.contracts.map((item) => {
        return {
          ...item,
          date_appointed: dayjs(item?.date_appointed).format("DD-MMM-YYYY"),
        };
      });

      console.log(contracts);

      if (application_id) {
        await axios
          .post(`${SERVER_BASE_URL}/application/update_application`, {
            server_id: application_id,
            updates: {
              contracts: contracts,
              mga: mga,
              progress:
                progress > Number(steps_array[page].percent)
                  ? progress
                  : Number(steps_array[page].percent),
              no_mga: data?.no_mga,
            },
          })
          .then((response) => {
            console.log(response);
            setProgress(
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent)
            );
            let contracts = _.merge(
              [],
              response.data?.data?.contracts,
              data?.contracts
            );

            let mga = _.merge([], data?.mga, response.data?.data?.mga);

            setData({ ...data, contracts: contracts, mga: mga });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else if (page === 4) {
      let is_subform_valid = error_check_fn({
        required_fields: [
          "pl_first_name",
          "pl_last_name",
          "pl_title",
          "cra_first_name",
          "cra_last_name",
          "cra_title",
          "acc_first_name",
          "acc_last_name",
          "acc_title",
        ],
        required_email: [
          "pl_email",
          "cra_email",
          "acc_email",
          "marketing_email",
          "product_training_email",
        ],
        required_phone: ["cra_phone", "pl_phone", "acc_phone"],
        required_checkbox: ["consent_forward"],
        data,
        error,
        setError,
      });

      if (!is_subform_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      await axios
        .post(`${SERVER_BASE_URL}/application/update_application`, {
          server_id: application_id,
          updates: {
            personal_line_first_name: data?.pl_first_name,
            personal_line_last_name: data?.pl_last_name,
            personal_line_title: data?.pl_title,
            personal_line_email: data?.pl_email,
            personal_line_phone: data?.pl_phone,
            cra_first_name: data?.cra_first_name,
            cra_last_name: data?.cra_last_name,
            cra_title: data?.cra_title,
            cra_email: data?.cra_email,
            cra_phone: data?.cra_phone,
            accounting_first_name: data?.acc_first_name,
            accounting_last_name: data?.acc_last_name,
            accounting_title: data?.acc_title,
            accounting_email: data?.acc_email,
            accounting_phone: data?.acc_phone,
            marketing_email: data?.marketing_email,
            product_training_email: data?.product_training_email,
            agree_to_sending_email: data?.consent_forward,
            progress:
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent),
          },
        })
        .then((response) => {
          console.log(response);
          setProgress(
            progress > Number(steps_array[page].percent)
              ? progress
              : Number(steps_array[page].percent)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (page === 5) {
      let is_subform_valid = error_check_fn({
        required_subform: ["user_accounts"],
        data,
        error,
        setError,
      });

      if (!is_subform_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      await axios
        .post(`${SERVER_BASE_URL}/application/update_application`, {
          server_id: application_id,
          updates: {
            user_accounts: data?.user_accounts,
            progress:
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent),
          },
        })
        .then((response) => {
          console.log(response);
          setProgress(
            progress > Number(steps_array[page].percent)
              ? progress
              : Number(steps_array[page].percent)
          );
          let user_accounts = _.merge(
            [],
            data?.user_accounts,
            response.data?.data?.user_accounts
          );

          setData({ ...data, user_accounts: user_accounts });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (page === 6) {
      let required_fields = [
        "eo_insurer",
        "eo_policy",
        "eo_limit",
        "cyber_insurer",
        "cyber_limit",
        "has_eando_claims_in_last_5years",
        "any_licensce_suspended",
        "brokerage_reprimanded_in_5years",
      ];

      if (!data?.eo_expiry_date) {
        required_fields.push("eo_expiry_date");
      }
      if (data?.has_eando_claims_in_last_5years === "Yes") {
        required_fields.push("eando_claim_details");
      }

      if (data?.any_licensce_suspended === "Yes") {
        required_fields.push("suspended_details");
      }
      if (data?.brokerage_reprimanded_in_5years === "Yes") {
        required_fields.push("reprimand_details");
      }

      let is_subform_valid = error_check_fn({
        required_subform: ["licensing"],
        required_fields: required_fields,
        data,
        error,
        setError,
      });

      if (!is_subform_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      let licensing = data?.licensing.map((item) => {
        return {
          ...item,
          expiry_date: dayjs(item?.expiry_date).format("DD-MMM-YYYY"),
        };
      });

      console.log(data?.eo_limit_referral);

      if (application_id) {
        await axios
          .post(`${SERVER_BASE_URL}/application/update_application`, {
            server_id: application_id,
            updates: {
              e_and_o_insurer: data?.eo_insurer,
              e_and_o_policy: data?.eo_policy,
              e_and_o_policy_limit: data?.eo_limit,
              e_and_o_limit_referral: data?.eo_limit_referral,
              e_and_o_expiry_date: dayjs(data?.eo_expiry_date).format(
                "DD-MMM-YYYY"
              ),
              any_e_and_o_claims_in_5years:
                data?.has_eando_claims_in_last_5years === "Yes"
                  ? true
                  : data?.has_eando_claims_in_last_5years === "No"
                  ? false
                  : null,
              e_and_o_claims_details: data?.eando_claim_details,
              cyber_insurer: data?.cyber_insurer,
              cyber_limit: data?.cyber_limit,
              licensing: licensing,
              any_license_suspended:
                data?.any_licensce_suspended === "Yes"
                  ? true
                  : data?.any_licensce_suspended === "No"
                  ? false
                  : null,
              suspended_license_details: data?.suspended_details,
              is_brokerage_reprimanded_5years:
                data?.brokerage_reprimanded_in_5years === "Yes"
                  ? true
                  : data?.brokerage_reprimanded_in_5years === "No"
                  ? false
                  : null,
              reprimaned_details: data?.reprimand_details,
              progress:
                progress > Number(steps_array[page].percent)
                  ? progress
                  : Number(steps_array[page].percent),
            },
          })
          .then((response) => {
            console.log(response);
            setProgress(
              progress > Number(steps_array[page].percent)
                ? progress
                : Number(steps_array[page].percent)
            );
            let licensing = _.merge(
              [],
              response.data?.data?.licensing,
              data?.licensing
            );

            setData({ ...data, licensing: licensing });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else if (page === 7) {
      let required_fields = ["first_name", "last_name", "title"];
      if (!data?.date) {
        required_fields.push("date");
      }

      let is_valid = error_check_fn({
        required_fields: required_fields,
        required_checkbox: ["terms_agreed"],
        data,
        error,
        setError,
      });

      if (!is_valid) {
        setRedbox(true);
        setBtnLoading(false);

        return;
      }

      await axios
        .post(`${SERVER_BASE_URL}/application/update_application`, {
          server_id: application_id,
          updates: {
            first_name: data?.first_name,
            last_name: data?.last_name,
            title: data?.title,
            date: dayjs(data?.date).format("DD-MMM-YYYY"),
            agree_to_acknowledgement: data?.terms_agreed,
            progress: 100,
          },
        })
        .then((response) => {
          console.log(response);
          setProgress(100);

          let user_accounts = _.merge(
            [],
            data?.user_accounts,
            response.data?.data?.user_accounts
          );

          setData({ ...data, user_accounts: user_accounts });
        })
        .catch((err) => {
          console.log(err);
        });

      setBtnLoading(false);
    }

    if (page === 8) return;

    setRedbox(false);
    setBtnLoading(false);

    if (stop_navigation === false) {
      window.scrollTo(0, 0);
      setPage((prev) => prev + 1);
    }
  };

  return (
    <div className="quote_btns">
      {page === 2 && data?.register_as === "Download Registration Form" ? (
        ""
      ) : page !== 1 ? (
        <button className="back_btn" onClick={back}>
          Back
        </button>
      ) : (
        ""
      )}
      {(page === 2 && data?.register_as === "Download Registration Form") ||
      page === 8 ? (
        ""
      ) : (
        <button
          className="next_btn"
          onClick={next}
          disabled={btnLoading || offlineDisabled}
        >
          {page === 7 && data?.register_as === "Complete Registration Online"
            ? "Submit Application"
            : "Next"}

          {btnLoading ? <LoadingOutlined /> : ""}
        </button>
      )}
    </div>
  );
};

export default Buttons;
